import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { Router } from "@angular/router";
import { ButtonGroupItem, OmniarkUiModule } from "@corp-ais/omniark-ui";
import {
  ENRICHMENT_MODES,
  EnrichmentMode,
  parseEnrichmentMode,
} from "../enrichment-mode.model";
import { EnrichmentModeStore } from "../enrichment-mode.store";

const MODES = Object.keys(ENRICHMENT_MODES) as EnrichmentMode[];

@Component({
  selector: "app-enrichment-mode-switch",
  standalone: true,
  imports: [OmniarkUiModule],
  templateUrl: "./enrichment-mode-switch.html",
  styleUrl: "./enrichment-mode-switch.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnrichmentModeSwitch {
  private readonly store = inject(EnrichmentModeStore);
  private readonly router = inject(Router);

  readonly pageMode = input.required<EnrichmentMode>();

  protected readonly options = computed<ButtonGroupItem[]>(() =>
    MODES.filter((mode) => this.store.available(mode)).map((mode) => ({
      value: mode,
      label: ENRICHMENT_MODES[mode].label,
    })),
  );

  protected choose(value: unknown): void {
    const mode = parseEnrichmentMode(value);
    if (!mode || mode === this.pageMode()) return;
    this.store.set(mode);
    void this.router.navigate([ENRICHMENT_MODES[mode].root], {
      queryParamsHandling: "preserve",
    });
  }
}
